 
/* eslint-disable @angular-eslint/directive-selector */
 
import { Directive, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[notchmarkFullNameOnly]'
})
export class FullNameOnlyDirective {
  private readonly control = inject(NgControl);

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // 1. Remove emojis and non-alphabetic characters except space
    value = value.replace(/[^a-zA-Z\s]/g, '');

    // 2. Replace multiple spaces with single space
    value = value.replace(/\s{2,}/g, ' ');

    // 3. Trim leading/trailing spaces
    value = value.trimStart();

    this.control.control?.setValue(value, { emitEvent: false });
  }
}



